module.exports = "/img/banner-m.a79410ad.png";